import {
    dataLayerLoginSecondStep,
    dataLayerRegistrationCode,
    dataLayerRegistrationCodeConfirmed,
    dataLayerRegistrationFinished,
    dataLayerRegistrationPasswordCreation,
    dataLayerRegistrationPersonal,
    dataLayerVerifyPhone,
} from "@/data-layer/services/account";
import { AuthenticationStepType } from "../models/authentication-flows";
import { dataLayerRegistrationSuccess } from "@/data-layer/services/actions";
import { settings } from "@/settings";

export function flowDataLayerService(accoountState: AuthenticationStepType) {
    switch (accoountState) {
        case "RegPersonal":
            dataLayerRegistrationPersonal();
            break;
        case "LoginPass":
            dataLayerLoginSecondStep();
            break;
        case "RegVerPhone":
        case "RegPinLog":
            dataLayerVerifyPhone();
            dataLayerRegistrationCode();
            break;
        case "RegPinOk":
            dataLayerRegistrationCodeConfirmed();
            break;
        case "RegNewPass":
            dataLayerRegistrationPasswordCreation();
            break;
        case "LoginWelcome":
            dataLayerRegistrationSuccess("online");
            dataLayerRegistrationFinished();
            break;
    }
}

let isAuthorisationRestricted: boolean = null;
const getIsAuthorisationRestricted = () => {
    if (isAuthorisationRestricted === null) {
        isAuthorisationRestricted = settings.authentication.restrictedFunctionsPages.some((url) => url == window.location.pathname);
    }

    return isAuthorisationRestricted;
};

export function restrictedAuthenticationService(userName?: string): boolean {
    if (getIsAuthorisationRestricted()) {
        if (userName) {
            window.location.href = `${settings.url.root}?akce=login&username=${userName}`;
        } else {
            window.location.href = `${settings.url.root}?akce=login`;
        }

        return true;
    }

    return false;
}
